module.exports = __webpack_public_path__ + "static/maxima-99154c07fe23fc9b2ac2425b3ff457d9.png";